// @flow

import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import Radio from 'common/domain/radio';
import RadioUser from 'statsradio/domain/RadioUser';

const Text = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

const LogoWrapper = styled.div`
  height: 50px;
  position: relative;
  padding: ${({ theme }) => theme.metrics.tinyMargin}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

const RadioPopoverCard = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({ theme }) => theme.metrics.smallMargin}px 0;
  padding: ${({ theme }) => theme.metrics.smallMargin}px ${({ theme }) => theme.metrics.margin}px;
  cursor: pointer;
  
  ${({ notReady, theme }) => (notReady && `
    background-color: ${theme.colors.secondaryBackground}
  `) || ''}

  :hover {
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
  }
`;


interface Props {
  user?: RadioUser;
  radio: Radio;
  onSelectRadio: (radio: Radio) => void;

  theme: any;
}


export function RadioListingItem({ user, radio, onSelectRadio, theme }: Props) {
  function onClick() {
    onSelectRadio(radio);
  }

  const radioIsReady = radio.isReady();
  const displayRadioNotReady = user && user.isAdministrator() && !radioIsReady;

  return (
    <RadioPopoverCard className="row" key={radio.callSign} onClick={onClick} notReady={displayRadioNotReady}>
      <LogoWrapper className="col-lg-3 col-xs-3">
        <Logo src={radio.logo} />
      </LogoWrapper>
      <div className="col-lg-8 col-lg-offset-1 col-xs-8 col-xs-offset-1">
        <Text style={theme.fonts.style.sub}>{radio.name}</Text>
        <Text style={theme.fonts.style.small}>{radio.callSign}</Text>
      </div>
    </RadioPopoverCard>
  );
}

export default withTheme(RadioListingItem);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radio/components/RadioListingItem.js